// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { OnlineCourse } from '../../../types/Model';

export interface OnlineCourseRequestPayload {
  id: number;
  preventLoading?: boolean;
}
export interface OnlineCourseSuccessPayload {
  onlineCourseData: OnlineCourse;
}

export interface OnlineCourseFailPayload {
  error: Error;
}

const getOnlineCourseDataActions = createAsyncAction(
  'elearning/GET_ONLINE_COURSE_DATA',
  'elearning/GET_ONLINE_COURSE_DATA_SUCCESS',
  'elearning/GET_ONLINE_COURSE_DATA_FAIL'
)<
  OnlineCourseRequestPayload,
  OnlineCourseSuccessPayload,
  OnlineCourseFailPayload
>();

export { getOnlineCourseDataActions as default }
